import {
  Table,
  TableColumns,
} from '@energybox/react-ui-library/dist/components';
import {
  ACConsumptionRecommendations,
  EnergyTariff,
} from '@energybox/react-ui-library/dist/types';
import { global } from '@energybox/react-ui-library/dist/utils';

import React from 'react';
import reportStyles from '../../../views/report/ReportPage.module.css';
import TemperatureCell from '../../TemperatureCell';

type Props = {
  ACConsumptionRecommendations: ACConsumptionRecommendations[];
  currency?: string;
  tariff?: EnergyTariff | null;
};

const ACConsumptionTable = ({
  currency,
  ACConsumptionRecommendations,
  tariff,
}: Props) => {
  if (ACConsumptionRecommendations.length === 0) return null;

  const savingsHeader =
    !currency || !tariff
      ? 'Estimated Savings*'
      : `Estimated Savings (${currency})*`;

  const getSavingsValue = (savings: number) =>
    !tariff ? global.NOT_AVAILABLE : (tariff.tariff * savings).toFixed(2);
  const columns: TableColumns<ACConsumptionRecommendations>[] = [
    {
      header: <div className={reportStyles.tableHeader}>#</div>,
      cellContent: (row: ACConsumptionRecommendations) => (
        <div className={reportStyles.tableCell}>{row.idx}</div>
      ),
    },
    {
      header: <div className={reportStyles.tableHeader}>Equipment</div>,
      width: '30%',
      cellContent: (row: ACConsumptionRecommendations) => (
        <div className={reportStyles.tableCell}>{row.equipmentName}</div>
      ),
    },
    {
      header: (
        <div className={reportStyles.tableHeader}>Dissatisfied Customers</div>
      ),
      align: 'right',
      cellContent: (row: ACConsumptionRecommendations) => (
        <div
          className={`${reportStyles.tableCell} ${reportStyles.tableCellRightAlign}`}
        >{`${row.dissatisfiedCustomers.toFixed(2)}%`}</div>
      ),
    },
    {
      header: (
        <div className={reportStyles.tableHeader}>Settings Adjustment</div>
      ),
      align: 'right',
      cellContent: (row: ACConsumptionRecommendations) => (
        <TemperatureCell
          displayTemperatureDifference
          temperatureInCelsius={row.settingsAdjustment}
        />
      ),
    },
    {
      header: <div className={reportStyles.tableHeader}>{savingsHeader}</div>,
      align: 'right',
      cellContent: (row: ACConsumptionRecommendations) => (
        <div
          className={`${reportStyles.tableCell} ${reportStyles.tableCellRightAlign}`}
        >
          {getSavingsValue(row.savings)}
        </div>
      ),
    },
  ];

  return (
    <div style={{ marginTop: '1rem' }}>
      <Table
        highlightAlternateRows
        columns={columns}
        data={ACConsumptionRecommendations}
      />
    </div>
  );
};

export default ACConsumptionTable;
